import { requestCall, requestCallNoAccess, handleError } from '../api/request';

export const subscribeRequest = (payload, token, callback) => {
    const url = '/api/core/subscription/subscribe/';
    requestCall(url, token, 'POST', payload)
        .then((response) => {
            callback(false, response.data);
        })
        .catch((error) => {
            handleError(error, callback);
        });
};

export const getSubscriptionMeta = (token, callback) => {
    requestCall('/api/core/subscription/meta/', token, 'GET')
        .then((res) => callback(false, res.data))
        .catch((err) => handleError(err, callback));
};

export const paySubscription = (payload, callback) => {
    const url = '/api/core/processor/buy';
    requestCallNoAccess(url, 'POST', payload)
        .then((response) => {
            const message = response.data['detail'];
            callback(false, message);
        })
        .catch((error) => handleError(error, callback));
};

export const getSubscriptionStatus = (token, callback) => {
    const url = '/api/core/subscription/status/';

    requestCall(url, token, 'GET')
        .then((response) => {
            callback(false, response.data);
        })
        .catch((error) => {
            handleError(error, callback);
        });
};
